import RiArrowDownSLine from '@ben/icons/arrow-down-s-line';
import Badge from '@ben/orion/badge';
import { BadgeVariant } from '@ben/orion/badge/badge';
import RIcon from '@ben/orion/remix-icon';
import { useTranslation } from 'react-i18next';

interface RightSectionProps {
  withChildren: boolean;
  notificationCount?: number;
}

const RightSection = ({
  withChildren,
  notificationCount,
}: RightSectionProps) => {
  const { t } = useTranslation();
  if (withChildren) {
    return <RIcon icon={RiArrowDownSLine} />;
  }

  if (notificationCount) {
    const notificationsText =
      notificationCount === 1
        ? t('menu.notification')
        : t('menu.notifications');
    return (
      <Badge
        text={notificationCount}
        variant={BadgeVariant.Main}
        aria-label={`${notificationCount} ${notificationsText}`}
      />
    );
  }
  return;
};

export default RightSection;
